<template>
  <div class="curriculum-management-body" v-loading="isLoading">
    <!-- 步骤条 -->
    <div class="curriculum-management-steps" v-if="isStepShow">
      <el-steps :active="active" finish-status="success" simple>
        <el-step title="选择班级/科目"></el-step>
        <el-step title="选择老师与课室"></el-step>
        <el-step title="课程编排"></el-step>
      </el-steps>
    </div>
    <div class="curriculum-management-main">
      <curriculumCourseChoose
        v-if="active == 0"
        @submitSelectedCourseList="receiveSelectedCourseList"
      />
      <curriculumTeacherChoose
        v-if="active == 1"
        :selectedCourseList="selectedCourseList"
        :currentClass="currentClass"
        @submitComplateCourseModule="receiveComplateCourseModule"
      />
      <curriculumManagement
        v-if="active == 2"
        :courseList="complateCorseModuleList"
        :isStepShow="isStepShow"
        :currentClass="currentClass"
        @currentUserNotSetCurriculumTable="currentUserNotSetCurriculumTable"
        @setCourseListAgain="setCourseListAgain"
        @changeEstablish="changeEstablish"
        @isStepShowChange="isStepShowChange"
      />
    </div>
  </div>
</template>

<script>
import curriculumCourseChoose from "./components/curriculum-course-choose/curriculumCourseChoose";
import curriculumTeacherChoose from "./components/curriculum-teacher-choose/curriculumTeacherChoose";
import curriculumManagement from "./components/curriculum-management/curriculumManagement";
export default {
  components: {
    curriculumCourseChoose,
    curriculumTeacherChoose,
    curriculumManagement,
  },
  data() {
    return {
      active: 2,
      selectedCourseList: [],
      complateCorseModuleList: [],
      isLoading: false,
      isStepShow: false,
      currentClass: "",
    };
  },
  created() {},
  methods: {
    // 顶部步骤切换显示-保存时取消显示
    isStepShowChange(e) {
      this.isStepShow = e;
    },
    // 切换课程编排
    changeEstablish(e) {
      // console.log("当前选中的班级==>", e);
      this.currentClass = e;
      this.active = 0;
      this.isStepShow = true;
    },
    currentUserNotSetCurriculumTable() {
      this.active = 0;
    },
    receiveSelectedCourseList(selectedCourseList) {
      this.selectedCourseList = selectedCourseList;
      this.active = 1;
      this.isStepShow = true;
    },
    receiveComplateCourseModule(complateCorseModuleList) {
      this.complateCorseModuleList = complateCorseModuleList;
      this.active = 2;
      this.isStepShow = true;
    },
    setCourseListAgain() {
      this.active = 0;
      this.isStepShow = true;
    },
  },
};
</script>

<style scoped lang="scss">
@import "./curriculum.scss";
</style>